import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { type ChatWelcomeProps, patientAgentMessages } from '../config';

import styles from './AgentChat.module.scss';

export const ChatWelcome: FC<ChatWelcomeProps> = ({
  patientName,
  entityName,
  isGeneralDraft,
  variant,
  writePresets,
  understandPresets,
  onPresetClick,
  className,
}) => {
  const intl = useIntl();
  const presets = [...writePresets, ...understandPresets].slice(0, 6);
  // Full patient name plus the bound entity (report type + date, document
  // title, encounter name) when the chat is bound to one.
  const scopeName =
    patientName && entityName ? `${patientName} · ${entityName}` : patientName;

  return (
    <div
      className={cn(
        styles.welcome,
        variant === 'shell' && styles.welcomeShell,
        isGeneralDraft && styles.welcomeGeneral,
        className,
      )}
    >
      <h4>
        {isGeneralDraft
          ? intl.formatMessage(patientAgentMessages.askAnything)
          : scopeName
            ? intl.formatMessage(patientAgentMessages.shellGreeting, {
                name: scopeName,
              })
            : intl.formatMessage(patientAgentMessages.welcomeGeneric)}
      </h4>
      {isGeneralDraft ? null : (
        <section
          className={cn(
            styles.intentGroup,
            variant === 'shell' && styles.starterGrid,
          )}
        >
          <div className={styles.starterGridItems}>
            {presets.map(({ title, prompt }) => (
              <button
                key={title}
                type="button"
                className={styles.starterGridItem}
                onClick={() => onPresetClick(prompt)}
              >
                {title}
              </button>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};
